import request from '@/utils/request'

export function list(params) {
  return request({
    url: '/system/menu/list',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/system/menu',
    method: 'post',
    data
  })
}
export function update(data) {
  return request({
    url: '/system/menu',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/system/menu/batch',
    method: 'delete',
    data: ids
  })
}

export function getRouters() {
  return request({
    url: '/system/menu/routers',
    method: 'get'
  })
}
